import { BooleanParam, withDefault } from 'use-query-params';

export const NOTES_LIBRARY_QUERY_CONFIG = {
    name: 'notesLibrary',
    type: withDefault(BooleanParam, false),
}
